import React from 'react';
import { Checkbox } from 'antd';
import { roundNum } from 'common/utils.js';
import moment from 'moment';
import * as echarts from 'echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/tooltip';
import store from 'common/redux/store.js';

import style from './TrendChart.module.scss';

export default class TrendChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            record: props.record,
            tag2Value: store.getState().mainPageV2.tag2Value,
            dataList: props.dataList || [],
            topTimeList: (props.optResult?.result?.kpi_result?.top_state_datetime ?? [])
                .map(item => ({ value: item[0], checked: true }))
        };

        this.option = this.buildOption();
        this.sChart = null;
    }

    buildOption = () => ({
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                let result = moment(params?.[0]?.axisValue).format('HH:mm:ss');
                result += '<div style="height:4px;"></div>';

                params.forEach(item => {
                    result += `
                        <div style="margin-top:1px;line-height:22px;">
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>
                            ${item.data?.[1] ?? ''}
                        </div>
                    `;
                });

                return result;
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '3%',
            containLabel: true
        },
        xAxis: { type: 'time' },
        yAxis: {
            type: 'value',
            scale: true,
            axisLabel: {
                formatter: v => roundNum(v, 2)
            }
        },
        series: []
    });

    componentDidMount() {
        this.sChart = echarts.init(this.chartNode);
        this.sChart.showLoading({ text: '加载中...' });

        this.updateChart(true);

        this.storeUnsubscribe = store.subscribe(() => {
            const { tag2Value } = store.getState().mainPageV2;
            this.setState({ tag2Value });
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.dataList !== this.props.dataList ||
            prevProps.record !== this.props.record
        ) {
            this.setState({
                dataList: this.props.dataList || [],
                record: this.props.record
            }, () => this.updateChart(true));
        }
    }

    componentWillUnmount() {
        this.storeUnsubscribe?.();
        this.sChart?.dispose();
        this.sChart = null;
    }

    resampleDataTime = (beginSec, dataList) => {
        let offsetSec = null;

        return dataList.map((data, setIndex) => {
            let data_list = [];

            if (setIndex === 0) {
                data_list = data.data_list.map(item => [item[0] * 1000, item[1]]);
            } else {
                data_list = data.data_list.map((item, index) => {
                    if (index === 0) offsetSec = beginSec - item[0];
                    return [(item[0] + offsetSec) * 1000, item[1]];
                });
            }

            return {
                ...data,
                checked: true,
                data_list
            };
        });
    }

    updateChart = (animation = false) => {
        if (!this.sChart) return;

        const record = this.state.record;
        const dataList = this.state.dataList;

        this.option.animation = animation;

        this.option.series = dataList
            .filter(i => i.checked)
            .map(item => ({
                type: 'line',
                smooth: true,
                symbol: 'none',
                color:
                    item.time_begin === this.props.curr_time_begin.format('YYYY-MM-DD HH:mm:ss')
                        ? '#ff0000'
                        : '#357cf7',
                data: item.data_list
            }));

        let min = Infinity;
        let max = -Infinity;

        dataList.forEach(item => {
            item.data_list.forEach(d => {
                min = Math.min(min, d[1]);
                max = Math.max(max, d[1]);
            });
        });

        this.option.yAxis.min = min;
        this.option.yAxis.max = max;

        this.sChart.hideLoading();
        this.sChart.setOption(this.option, true);
    }

    onChangeTime = (checked, item) => {
        const newDataList = this.state.dataList.map(i =>
            i === item ? { ...i, checked } : i
        );

        this.setState({ dataList: newDataList }, () => {
            this.updateChart(false);
        });
    }

    render() {
        const r = this.state.record;

        return (
            <div className={style["PA_TrendChart"]}>
                <div className="left-content">
                    <div className="info-bar">
                        <div>参数名称：<b>{r?.name}</b></div>
                        <div>当前值：{this.state.tag2Value?.[r?.cur_value_tag]}</div>
                        <div>推荐区间：{r?.bound_low} ~ {r?.bound_high}</div>
                    </div>

                    <div
                        className="chart-node"
                        ref={node => this.chartNode = node}
                    />
                </div>

                <div className="time-options">
                    {this.state.dataList.map((item, index) => (
                        <Checkbox
                            key={index}
                            checked={item.checked}
                            onChange={e => this.onChangeTime(e.target.checked, item)}
                        >
                            {item.time_begin === this.props.curr_time_begin.format('YYYY-MM-DD HH:mm:ss')
                                ? '近期趋势'
                                : item.time_begin}
                        </Checkbox>
                    ))}
                </div>
            </div>
        );
    }
}